import React from 'react'
import { connect } from 'react-redux'
import InputRange from 'react-input-range'
import PropTypes from 'prop-types'
import { Input } from 'loyal-react'
import RangePlaceholder from './RangePlaceholder'
import 'react-input-range/lib/css/index.css'

const numberToStrCurrency = (value, decimalPlaces) => {
  return value.toLocaleString('pt-br', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  })
}

const strCurrencyToNumber = value => {
  return value
    .split('.')
    .join('')
    .replace(',', '.')
}

export class Range extends React.Component {
  state = {
    points: this.props.payment.pointsCashConfig.maxPointForCash,
    minimulParcelCash: 5,
    maxPointForCash: this.props.payment.pointsCashConfig.maxPointForCash
  }

  componentDidMount () {
    let { points } = this.state
    const { decimalPlaces, totalFundsParticipant, totalOrder } = this.props.payment.pointsCashConfig

    if (points > totalFundsParticipant) points = totalFundsParticipant

    if (points > totalOrder) points = totalOrder

    this.handleRangeChange(points)
    this.handleRangeLimiteValue()
    this.props.fetchInstallments(points)

    const step =
      decimalPlaces > 0
        ? parseFloat(`0.${'1'.padStart(decimalPlaces, '0')}`)
        : 1
    this.setState({ step })
  }

  handleRangeChangeComplete = value => {
    this.props.fetchInstallments(value)
  }

  handleRangeLimiteValue = () => {}

  handleCash = points => {
    const { pointsCashConfig } = this.props.payment
    const {
      markup,
      conversionRate,
      maxPointForCash,
      totalOrder,
      totalFundsParticipant
    } = pointsCashConfig

    if (points > totalOrder) points = totalOrder

    if (points > totalFundsParticipant) points = totalFundsParticipant

    let pointsCash = parseFloat(points)
    if (maxPointForCash - points < 0) pointsCash = maxPointForCash

    const pointsDiference = totalOrder - pointsCash
    const valueCurrency = pointsDiference / conversionRate
    const markupCurrency = (valueCurrency * markup) / 100

    const cash = valueCurrency + markupCurrency
    this.setState({ cash })

    return cash
  }

  handleRangeChange = points => {
    let { totalFundsParticipant, totalOrder } = this.props.payment.pointsCashConfig
    if (points > totalFundsParticipant) points = totalFundsParticipant
    if (points > totalOrder) points = totalOrder
    this.setState(() => ({ points, cash: this.handleCash(points) }))
  }

  handleValueBlur = _ => this.props.fetchInstallments(numberToStrCurrency(this.state.cash || 0, 2))

  handleValueChange = ({ target: { value } }) => {
    let points = strCurrencyToNumber(value)
    this.setState({ points })
  }

  render () {
    const {
      installments: { items },
      pointsCashConfig
    } = this.props.payment

    if (!this.props.showCashWithTotalPoints) {
      if (!items || items.length < 1) {
        return <RangePlaceholder />
      }
    }

    const { minPointForCash, decimalPlaces } = pointsCashConfig

    return (
      <div className='range-step row border-color-ui-3 border-bottom pb-2 mb-2'>
        <div className='col-6 col-md-3 order-2 order-md-1 px-0'>
          <div className='row'>
            <Input
              id='pontos'
              label={`Valor em ${this.props.pointsName}`}
              className='form-field col-12 mt-0'
              value={numberToStrCurrency(this.state.points, decimalPlaces)}
              onChange={this.handleValueChange}
              onBlur={this.handleValueBlur}
              disabled
            />
          </div>
        </div>
        <div className='col-12 col-md-6 order-1 order-md-2 px-0'>
          <div className='row align-items-center h-100'>
            <div className='col-12 px-2 mb-2 mb-md-0'>
              <InputRange
                minValue={minPointForCash}
                maxValue={this.state.maxPointForCash}
                value={this.state.points}
                onChange={this.handleRangeChange}
                onChangeComplete={this.handleRangeChangeComplete}
                step={this.state.step}
                ariaLabelledby={this.props.sliderAriaLabelledby}
              />
            </div>
          </div>
        </div>
        <div className='col-6 col-md-3 order-3 order-md-3  form-field'>
          <div className='row'>
            <Input
              id='cash'
              label='Valor em R$'
              className='form-field col-12 mt-0'
              value={numberToStrCurrency(this.state.cash || 0, 2)}
              disabled
            />
          </div>
        </div>
      </div>
    )
  }
}

Range.propTypes = {
  payment: PropTypes.object.isRequired,
  fetchInstallments: PropTypes.func.isRequired,
  pointsName: PropTypes.string.isRequired,
  sliderAriaLabelledby: PropTypes.string,
  showCashWithTotalPoints: PropTypes.bool.isRequired
}

const mapStateToProps = ({ catalog: { currencyConfiguration, showCashWithTotalPoints } }) => ({
  pointsName: currencyConfiguration.pointsName,
  showCashWithTotalPoints
})

export default connect(
  mapStateToProps,
  null
)(Range)



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/Range.js